import React, { ComponentType, useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

export const BettingContext = React.createContext({});

type WrapperComponent<C> = C & {
  WrappedComponent?: C;
};

// TODO: Если появится время, то нужно будет выпилить этот компонент и сделать через createWithinContext
// Потому что тут один и тот же код повторяется кучу раз

/**
 * A higher-order component to access betting context API.
 */
export const withinBettingContext = <Props extends Record<string, unknown>>(
  TargetComponent: ComponentType<Props>,
): ComponentType<Props> => {
  const C: WrapperComponent<ComponentType<Props>> = (props: Props) => {
    const $betting = useContext(BettingContext);
    return (
      <TargetComponent $betting={$betting}
                       {...props} />
    );
  };

  C.displayName = `withinBettingContext(${TargetComponent.displayName || TargetComponent.name})`;
  C.WrappedComponent = TargetComponent;

  return hoistNonReactStatics(C, TargetComponent);
};
